/**
* @name: portal-sel-list
* @author: weiyong
* @date: 2023-05-12 21:30
* @description：portal-sel-list
* @update: 2023-05-12 21:30
*/
<template>
  <div :class="prefixCls" class="um-box flex-div h100b">
    <div class="portal-items-body flex-div">
      <template v-for="(item,index) in getPcSpaceList">
        <a-tooltip v-if="index<3" :key="item.id">
          <template #title>{{ item.name || item.label }}</template>
          <div class="workbench-item um-box-center  flex-div" @click.stop="selSpaceItemFun(item)"
               :class="item.id===curActiveKey?'workbench-active':'workbench-not-active'">
            <div :style="getTechnologyFrameTextColor" class="workbench-item-label">{{ item.name || item.label }}</div>
          </div>
        </a-tooltip>
      </template>
    </div>

    <portal-more-sel ref="moreSelRef"
                     @setActiveKey="setActiveKey"
                     :curActiveKey="curActiveKey"
                     @selSpaceItemFun="selSpaceItemFun"
                     :curSelItem="getCurSpaceItem"
                     :workSpaceList="getPcSpaceList"></portal-more-sel>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "portal-sel-list",
});
</script>

<script lang="ts" setup>
import PortalMoreSel from "@/layouts/layoutFrame/portal-sel/portal-more-sel.vue";
import {Tooltip as aTooltip} from 'ant-design-vue'
import {useDesign} from "@/hooks/web/useDesign";
import {useSpaceHook} from "@/hooks/layouts/useSpaceHook";
import {nextTick, toRefs, unref} from "vue";
import {useRouter} from "vue-router";
import {StorageUtils} from 'xmgoing-utils';
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {useAppFrame} from "@/hooks/useAppFrame";

const {getTechnologyFrameTextColor} = useAppFrame();
const props = defineProps({
  spaceType: {
    type: String,
    default: 'main'
  }
});
const {spaceType} = toRefs(props)
const curActiveKey: any = ref(StorageUtils.getSessionItem(StorageUtils.getSessionItem('userId')+"_curSelSpaceItem") || '');
function setCurActiveKey(newList){
  if (newList && newList.length > 0) {
    if (curActiveKey.value == null || curActiveKey.value === "") {
      curActiveKey.value = newList[0].id;
    }
  }
}
const {
  panelSty,
  getPcSpaceList,
  selAppSpaceItem,
  selSpaceItem,
  getCurSpaceItem,
}:any = useSpaceHook();
//如果数据已经存在 则直接赋值
if(unref(getPcSpaceList)&&unref(getPcSpaceList).length>0){
  setCurActiveKey(unref(getPcSpaceList));
}

watch(getPcSpaceList, (newList: any) => {
  setCurActiveKey(newList);
})
const {prefixCls} = useDesign('portal-sel-list');
const moreSelRef: any = ref(null);
const router = useRouter();
const pcSpaceStore = usePcSpaceStore();
//首页门户切换
const selSpaceItemFun = function (item, otherItem = false) {
  pcSpaceStore.setLoadingFlag(true);
  curActiveKey.value = item.id;
  StorageUtils.addSessionItem("portal-curActiveKey", curActiveKey.value);
  if (otherItem === false) {
    moreSelRef.value.closeSelItem();
  }
  //如果是首页设计页面
  if (window.appObj.analysisSet) {
    return false;
  }
  if (unref(spaceType) === 'app') {
    router.push({path: '/dashboard/appMainPage'});
    nextTick(() => {
      selAppSpaceItem(item);
    })
  } else {
    router.push({path: '/dashboard'});
    nextTick(() => {
      selSpaceItem(item);
    })
  }
}

/**
 * 点击前三个
 */
const setActiveKey = function ({item}) {
  curActiveKey.value = item.id;
  StorageUtils.addSessionItem("portal-curActiveKey", curActiveKey.value)
}

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-portal-sel-list';
.@{prefix-cls} {
  &.um-box {
    height: var(--header-height,60px);
    align-items: center;

    .more-icon-div {
      position: relative;

      .more-icon {
        color: var(--header-font-color, #fff);
        cursor: pointer;
      }
    }

    .workbench-item {
      cursor: pointer;
      color: var(--workbench-header-c);
      display: flex;
      align-items: center;
      transition: all .3s;


      .workbench-item-label {
        display: none;
      }

      &.workbench-active {
        background: var(--workbench-header-s);

        .workbench-item-label {
          display: block;
        }
      }

      .workbench-item-label {
        font-size: 14px !important;
        padding: 0 6px;
        color: var(--header-font-color, #fff);
      }

      padding: 0 5px;
      width: auto;
      // margin-right: 10px;
      height: 26px;
      line-height: 26px;
      overflow: hidden;
      border-radius: 7px;

      img {
        display: block;
        width: 18px;
        height: 18px;
      }

      p {
        padding: 0 10px;
        font-size: 12px;
        word-break: keep-all;
      }
    }

    .more-icon-div-drop {
      left: 2px;
      top: 30px;
      min-width: 320px;
      border-radius: 4px;
      background-color: #FFF;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .16);
      font-size: 12px;
      font-weight: 400;
      line-height: 1.5;
      position: absolute;
      padding-top: 6px;
      z-index: 1200;
      transition: all .3s;

      .divider-xm {
        position: relative;
        height: 16px;
        line-height: 16px;
        display: flex;
        margin: 8px 0;
        height: 20px;

        span {
          position: absolute;
          left: 10px;
          top: 8px;
          width: 100%;
          height: 0;
          border-top: 1px dashed #ccc;
        }

        p {
          left: 68px;
          background: #fcfcfc;
          z-index: 1;
          padding: 0 2px;
          color: #999;
          font-size: 12px;
          max-width: 200px;
          word-wrap: break-word;
        }
      }

      .um-box-center {
        box-pack: center;
        justify-content: center;
      }

      .wui-menu-item {
        width: 100%;
        cursor: pointer;

        .check-icon {
          color: var(--primary-color, #0a6eff);
        }

        &:hover {
          background-color: var(--el-hover-bg-color, #DBE0E4);
        }

        .um-box-item {
          width: 100%;
          padding: 6px 2px;
          display: flex;
          align-items: center;

        }

        div i:first-child {
          color: #999;
          cursor: move;
        }

        .md__index___3HmlR {
          width: 20px;
        }

        .maxwidth {
          max-width: 138px;
        }

        .defaultPortalName {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 195px;
        }

        img {
          display: block;
          width: 32px;
          height: 32px;
          margin-left: 4px;
          margin-right: 8px;
          margin-top: -2px;
        }
      }
    }

  }
}
</style>
